export const safeUrl = (url) => (/^https?:\/\//i.test(url || "") ? url : undefined);
